import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class SingleSignOnOpenIdNotAvailableError extends CodedError {
  static get errorName() {
    return errorCodes.singleSignOnOpenIdNotAvailable.code;
  }

  constructor(message: string = errorCodes.singleSignOnOpenIdNotAvailable.message) {
    super(message);
    this.code = errorCodes.singleSignOnOpenIdNotAvailable.code;
    this.message = `${message} ${errorCodes.singleSignOnOpenIdNotAvailable.code}`;
    this.name = errorCodes.singleSignOnOpenIdNotAvailable.name;
  }
}
